import React from 'react';
import { fontOptions, colorPresets } from './DesignPanel';

function InlineTextPopover({
  inlinePopoverRef,
  inlineEditTarget,
  inlineEditRect,
  editableSettings,
  onDesignChange,
}) {
  if (!inlineEditTarget || !inlineEditRect || !editableSettings) return null;

  return (
    <div
      ref={inlinePopoverRef}
      className="showcase-inline-popover"
      style={{ top: inlineEditRect.top, left: inlineEditRect.left }}
    >
      <div className="showcase-inline-popover-label">
        {inlineEditTarget === 'heading' ? 'Heading' : 'Body'}
      </div>
      <select
        className="showcase-inline-popover-select"
        value={
          editableSettings[inlineEditTarget === 'heading' ? 'heading_font' : 'body_font'] || 'Inter'
        }
        onChange={(e) =>
          onDesignChange(
            inlineEditTarget === 'heading' ? 'heading_font' : 'body_font',
            e.target.value
          )
        }
      >
        {fontOptions.map((f) => (
          <option key={f} value={f} style={{ fontFamily: f }}>
            {f}
          </option>
        ))}
      </select>
      <div className="showcase-inline-popover-size">
        <input
          type="range"
          min={inlineEditTarget === 'heading' ? 20 : 12}
          max={inlineEditTarget === 'heading' ? 60 : 24}
          value={
            editableSettings[
              inlineEditTarget === 'heading' ? 'heading_font_size' : 'body_font_size'
            ] || (inlineEditTarget === 'heading' ? 32 : 16)
          }
          onChange={(e) =>
            onDesignChange(
              inlineEditTarget === 'heading' ? 'heading_font_size' : 'body_font_size',
              parseInt(e.target.value)
            )
          }
        />
        <span>
          {editableSettings[
            inlineEditTarget === 'heading' ? 'heading_font_size' : 'body_font_size'
          ] || (inlineEditTarget === 'heading' ? 32 : 16)}
          px
        </span>
      </div>
    </div>
  );
}

function InlineColorPopover({ colorPickerRef, colorPickerRect, editableSettings, onDesignChange }) {
  if (!colorPickerRect || !editableSettings) return null;

  return (
    <div
      ref={colorPickerRef}
      className="showcase-inline-popover"
      style={{ top: colorPickerRect.top, left: colorPickerRect.left }}
    >
      <div className="showcase-inline-popover-label">Accent Color</div>
      <div className="showcase-color-swatches">
        {colorPresets.map((color) => (
          <button
            key={color}
            className={`showcase-color-swatch${(editableSettings.accent_color || '#00D9C0') === color ? ' active' : ''}`}
            style={{ backgroundColor: color }}
            onClick={() => onDesignChange('accent_color', color)}
          />
        ))}
      </div>
      <div className="showcase-color-custom" style={{ marginTop: '8px' }}>
        <input
          type="color"
          value={editableSettings.accent_color || '#00D9C0'}
          onChange={(e) => onDesignChange('accent_color', e.target.value)}
          className="showcase-color-input"
        />
        <input
          type="text"
          value={editableSettings.accent_color || '#00D9C0'}
          onChange={(e) => {
            const v = e.target.value;
            if (/^#[0-9A-Fa-f]{0,6}$/.test(v)) onDesignChange('accent_color', v);
          }}
          className="showcase-color-hex"
          placeholder="#000000"
          maxLength={7}
        />
      </div>
    </div>
  );
}

export { InlineTextPopover, InlineColorPopover };
